export const paymentLimitsInitialState = {
    maxTransactionAmount: undefined,
    maxMonthlyTransactionAmount: undefined,
    bankLimits: undefined,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvd2lkZ2V0cy9VcGRhdGVQYXltZW50TGltaXRzL2Zvcm0vc3RhdGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUUEsTUFBTSxDQUFDLE1BQU0seUJBQXlCLEdBQXVCO0lBQ3pELG9CQUFvQixFQUFFLFNBQVM7SUFDL0IsMkJBQTJCLEVBQUUsU0FBUztJQUN0QyxVQUFVLEVBQUUsU0FBUztDQUN4QixDQUFDIn0=